export class DocTemp {
  Type;
  TempCode;
  CDesc;
  EDesc;
  DocContent;
  constructor() {
    this.Type = "";
    this.TempCode = "";
    this.CDesc = "";
    this.EDesc = "";
    this.DocContent = "";
  }
}



// WEBPACK FOOTER //
// ./src/model/DocTemp.js